<template>
  <block
    component-name="block-grid-decors"
    body-class="@container/grid-decors-inner"
  >
    <template v-slot:default="blockData">
      <div
        ref="tpl_grid"
        class="grid grid-cols-2 @md/grid-decors-inner:grid-cols-3 @xl/grid-decors-inner:grid-cols-4 @2xl/grid-decors-inner:grid-cols-5 gap-x-ui gap-y-3xl w-full"
      >
        <card-media
          v-for="(item, index) in blockData.data.items"
          :asset="{
            ...item.asset,
            sizes,
            loading:
              blockData?.loading === 'lazy' || index >= 15 ? 'lazy' : 'eager',
          }"
          :use-gallery="false"
          :use-favourite="true"
          :use-moodboard="true"
          :use-remove="false"
          class="col-span-1"
        />
      </div>
    </template>
  </block>
</template>

<script setup>
const tpl_grid = templateRef("tpl_grid");
const { width } = useElementSize(tpl_grid);

const sizes = computed(() => {
  let size;

  if (width.value >= 1920) size = 550;
  else if (width.value >= 1512) size = 500;
  else if (width.value >= 1272) size = 450;
  else if (width.value >= 1020) size = 550;
  else if (width.value >= 600) size = 500;
  else size = 300;

  return { base: size };
});
</script>
